var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 455,
    viewBox: "0 0 603 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M301.5 415.626C429.807 415.626 533.821 402.335 533.821 385.939C533.821 369.544 429.807 356.253 301.5 356.253C173.193 356.253 69.1792 369.544 69.1792 385.939C69.1792 402.335 173.193 415.626 301.5 415.626Z",
    fill: "#010031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M490.405 83.3533H170.212V305.965H490.405V83.3533Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M477.877 145.322H363.594V285.122H477.877V145.322Z",
    fill: "#0C3C66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.796 104.527H196.564V275.664H335.796V104.527Z",
    fill: "#4F8CC9",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335.796 104.527H196.564V119.899H335.796V104.527Z",
    fill: "#68B3FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M164.318 193.089C165.383 192.628 166.476 192.229 167.589 191.897C173.041 190.442 178.664 189.726 184.307 189.769C193.352 189.513 203.633 189.89 212.196 193.074C220.306 196.093 225.085 203.639 228.009 211.412C228.929 213.841 229.336 215.577 232.396 215.154C242.516 213.741 252.082 209.669 260.119 203.352C267.37 197.617 273.687 189.905 282.626 187.626C283.323 187.408 284.07 187.408 284.767 187.626C285.958 188.079 286.38 189.558 286.485 190.826C286.676 195.372 285.437 199.865 282.943 203.669C280.46 207.44 277.64 210.976 274.516 214.234C265.245 224.602 256.426 235.725 244.366 242.909C242.523 243.747 240.974 245.12 239.919 246.848C237.763 251.648 239.828 298.675 239.919 306.569H185.649L160.564 241.989C156.041 230.428 145.489 213.313 153.886 201.33C156.515 197.651 160.132 194.794 164.318 193.089V193.089Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M456.471 367.406C456.471 367.406 441.969 363.437 438.818 349.944C438.818 349.944 461.28 345.416 461.913 368.598L456.471 367.406Z",
    fill: "#68B3FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M458.28 365.972C458.28 365.972 448.165 349.944 457.074 334.957C457.074 334.957 474.139 345.809 466.556 366.002L458.28 365.972Z",
    fill: "#68B3FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M460.843 365.972C460.843 365.972 466.194 349.054 482.37 345.854C482.37 345.854 485.385 356.841 471.817 366.017L460.843 365.972Z",
    fill: "#68B3FD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M450.335 365.595L453.275 385.713L471.772 385.788L474.501 365.7L450.335 365.595Z",
    fill: "#24285B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102.721 309.949C102.721 309.949 103.942 328.06 112.49 323.306C121.037 318.552 110.334 309.949 110.334 309.949H102.721Z",
    fill: "#F4A28C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.087 192.667C129.087 192.667 68.5461 235.755 101.304 309.949H110.349C110.349 309.949 105.6 256.175 129.087 230.639C152.574 205.103 129.087 192.667 129.087 192.667Z",
    fill: "#68B3FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.087 192.667C129.087 192.667 68.5461 235.755 101.304 309.949H110.349C110.349 309.949 105.6 256.175 129.087 230.639C152.574 205.103 129.087 192.667 129.087 192.667Z",
    fill: "#68B3FD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.609 169.41L150.765 184.894L138.524 192.667L134.122 165.833L145.609 169.41Z",
    fill: "#F4A28C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.534 156.566C131.029 155.4 131.809 154.377 132.803 153.592C133.797 152.807 134.972 152.285 136.22 152.074C137.468 151.864 138.749 151.972 139.945 152.387C141.141 152.803 142.213 153.513 143.062 154.453C147.147 158.83 152.107 165.787 146.499 169.545C137.951 175.341 130.112 164.52 130.112 164.52C129.471 161.884 129.618 159.119 130.534 156.566Z",
    fill: "#F4A28C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.876 160.369C137.876 160.369 135.087 158.045 133.821 161.35C132.555 164.656 137.484 166.27 138.946 164.595C140.409 162.92 137.876 160.369 137.876 160.369Z",
    fill: "#F4A28C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.323 265.099L84.5308 280.527L95.2755 322.264L155.068 306.836L144.323 265.099Z",
    fill: "#00C792"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M115.55 271.736L125.122 299.943L124.61 313.843L138.343 310.342L144.449 285.288L127.806 268.536L115.55 271.736Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.248 200.334C126.095 196.236 128.801 192.583 132.182 189.625C135.564 186.667 139.542 184.472 143.846 183.189C160.428 178.193 191.076 183.657 200.407 199.232C213.191 220.542 194.483 288.277 194.483 288.277L138.69 292.518C138.69 292.518 107.907 237.023 124.248 200.334Z",
    fill: "#68B3FD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M194.498 288.186L187.156 384.339H175.533L165.162 309.632L139.474 292.518L194.498 288.186Z",
    fill: "#24285B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.474 292.518L123.449 384.339H135.901L162.81 308.063L139.474 292.518Z",
    fill: "#24285B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M148.685 181.65C148.685 181.65 122.56 265.925 198.025 271.509L194.467 288.186L138.69 292.518C138.69 292.518 119.002 261.578 119.846 218.113C119.846 218.113 120.314 196.621 135.434 187.113C139.412 184.369 143.93 182.506 148.685 181.65V181.65Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.359 384.143L118.821 389.682C118.52 389.88 118.292 390.172 118.172 390.512C118.053 390.852 118.049 391.223 118.16 391.566C118.271 391.909 118.492 392.206 118.789 392.411C119.085 392.616 119.441 392.718 119.801 392.701H132.374C132.809 392.701 133.227 392.527 133.535 392.219C133.844 391.91 134.017 391.492 134.017 391.055V384.188L126.359 384.143Z",
    fill: "#68B3FD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.694 384.143L192.764 389.682C193.058 389.888 193.277 390.184 193.389 390.526C193.501 390.868 193.499 391.236 193.383 391.576C193.267 391.917 193.045 392.21 192.748 392.413C192.452 392.616 192.098 392.717 191.739 392.701H182.784C181.517 392.701 180.301 392.197 179.405 391.299C178.509 390.402 178.006 389.185 178.006 387.916V384.188L185.694 384.143Z",
    fill: "#68B3FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130.851 167.795C130.851 167.795 133.579 172.745 138.087 171.206C142.594 169.666 139.353 159.011 139.353 159.011C139.353 159.011 144.81 151.133 144.026 144.9C143.898 144.161 143.538 143.483 142.998 142.964C142.458 142.446 141.766 142.113 141.024 142.015C140.282 141.918 139.528 142.06 138.872 142.421C138.216 142.783 137.693 143.344 137.378 144.024C136.863 144.977 136.108 145.777 135.187 146.347C134.267 146.916 133.214 147.234 132.132 147.269C124.459 148.114 117.419 160.249 130.851 167.795Z",
    fill: "#24285B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M184.91 186.751C184.91 186.751 221.437 207.307 232.818 207.307C244.2 207.307 272.601 185.86 272.601 185.86L278.631 198.387C278.631 198.387 254.511 236.027 232.954 233.099C211.397 230.171 178.036 211.351 178.036 211.351L184.91 186.751Z",
    fill: "#68B3FD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M272.601 185.906C272.601 185.906 277.923 174.933 279.687 175.069C281.45 175.205 280.772 178.737 280.772 178.737C280.772 178.737 286.47 172.353 288.098 173.303C289.727 174.254 289.862 188.517 278.601 198.432L272.601 185.906Z",
    fill: "#F4A28C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M490.405 63.3862H170.212V83.3534H490.405V63.3862Z",
    fill: "#24285B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M199.955 78.5991C202.844 78.5991 205.186 76.2544 205.186 73.362C205.186 70.4697 202.844 68.125 199.955 68.125C197.066 68.125 194.724 70.4697 194.724 73.362C194.724 76.2544 197.066 78.5991 199.955 78.5991Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.527 78.5991C218.416 78.5991 220.758 76.2544 220.758 73.362C220.758 70.4697 218.416 68.125 215.527 68.125C212.638 68.125 210.296 70.4697 210.296 73.362C210.296 76.2544 212.638 78.5991 215.527 78.5991Z",
    fill: "#68B3FD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M230.195 78.5991C233.084 78.5991 235.426 76.2544 235.426 73.362C235.426 70.4697 233.084 68.125 230.195 68.125C227.306 68.125 224.964 70.4697 224.964 73.362C224.964 76.2544 227.306 78.5991 230.195 78.5991Z",
    fill: "#00C792"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M466.86 131.453H352.557V271.253H466.86V131.453Z",
    fill: "#3D78A9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M466.86 131.453H352.557V144.266H466.86V131.453Z",
    fill: "#68B3FD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.845 104.211H355.407V116.496H466.845V104.211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPlant);
export default __webpack_public_path__ + "static/media/SelectPlant.814dfa58ec077cefb41c95a03d2c13f4.svg";
export { ForwardRef as ReactComponent };